module.exports = __webpack_public_path__ + "media/react/pages/mock_tests/free/about_magoosh_content/assets/hands_raised-dc1bea9bd916483719735b224116b814.svg";